import { Link } from "react-router-dom";
import { useT } from "../i18n/LanguageProvider";

/**
 * G-133 / OD-168 — what a browser sees at `/app/in-the-shop`. Kiosk mode runs
 * only inside the tablet app (`kioskAllowedOnThisDevice`), so a phone or a
 * desktop gets a plain explanation and a way back instead of the lock screen.
 */
export function KioskShellOnly() {
  const { t } = useT();
  return (
    <div className="login-shell">
      <div className="login-card kiosk-shell-only">
        <h1 className="page-title">{t("arm.shellOnlyTitle")}</h1>
        <p className="page-subtitle">{t("arm.shellOnlyBody")}</p>
        <Link className="button tinted" to="/app">
          {t("arm.backToApp")}
        </Link>
      </div>
    </div>
  );
}
